import { logo } from "../../constants";

export default function AdszieBanner() {
  return (
    <section className="relative flex justify-center">
      <div
        className="w-full"
        style={{ backgroundColor: "#0d1821" }}
        aria-label="Adszie banner"
      >
        <div className="text-center">
          {/* Main logo text */}
          <h1 className="pt-3 md:pt-2 uppercase mx-auto text-[#f5f5f5] text-[53px] leading-none md:text-6xl font-medium">
            <img
              src={logo}
              alt="Adszie Logo"
              className="mx-auto w-[276px] object-contain"
            />
          </h1>

          {/* Tagline row */}
          <div className="flex flex-row items-center justify-center gap-2 md:gap-4">
            <TagItem label="Marketing" />
            <SquareSeparator />
            <TagItem label="Branding" />
            <SquareSeparator />
            <TagItem label="Advertising" />
            <SquareSeparator />
            <TagItem label="Tech" />
          </div>
        </div>
      </div>
    </section>
  );
}

function TagItem({ label }) {
  return (
    <div className="flex items-center select-none">
      <span
        className="font-poppins text-[14px] md:text-md font-[500] tracking-wider"
        style={{ color: "#f5f5f5" }}
      >
        {label}
      </span>
    </div>
  );
}

function SquareSeparator() {
  // black rounded square used as separator between tag items
  return (
    <span
      className="inline-block"
      style={{
        width: 10,
        height: 10,
        backgroundColor: "#c3f620",
        borderRadius: 3,
        display: "inline-block",
      }}
      aria-hidden="true"
    />
  );
}
